<template>
  <ur-screen>
    <div class="body-wrapper">
      <ur-area right class="custom-content">
        <div class="page-custom-container">
          <router-view />
        </div>
      </ur-area>
    </div>
    <ur-area>
      <LayoutFooter />
    </ur-area>
  </ur-screen>
</template>

<script>
export default {
  name: "AuthLayout",
};
</script>

<style lang="less">
.body-wrapper {
  display: flex;
  height: calc(100vh - 74px);
  clear: both;
}
.sidebar-area {
  display: inline-block;
}
.ur-system {
  min-height: auto !important;
}
</style>
